import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconTriangle(props: SvgIconProps) {
  return (
    <SVGIcon width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.62916 1.25L-5.24538e-07 11L13.8564 11L8.22724 1.25C7.64989 0.250001 6.20651 0.249999 5.62916 1.25Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
}
